import './IssuesList.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Issue } from './Issue';
import { NoData } from '@ui/NoData';
import { PaginatedList } from '@ui/lists';
import { Result } from 'antd';
import { take } from '@sonar-software/sonar-ts-lib';
import { useSelector } from 'react-redux';
import { createAsyncSelectors } from '@lib/selectors';
import { issuesActions, IssueVisibilityType } from '@sonar-software/sonar-issues';
import { keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import React, { useEffect, useMemo } from 'react';
import { useAction, useQueryParams } from '@hooks';
function getLimitedIssues(paginatedIssues, limit) {
    var _a;
    if (!paginatedIssues || !limit) {
        return paginatedIssues;
    }
    return Object.assign(Object.assign({}, paginatedIssues), { results: take(paginatedIssues.results, limit), totalCount: ((_a = paginatedIssues.totalCount) !== null && _a !== void 0 ? _a : 0) > limit ? paginatedIssues : paginatedIssues.totalCount });
}
const visiblityTypeMap = {
    [IssueVisibilityType.Archived]: {
        action: issuesActions.requestGetIssuesArchived,
        empty: React.createElement(NoData, { description: COPY_SPECIFIC.NO_ISSUES_ARCHIVED }),
        selectors: createAsyncSelectors((state) => state.issues.archived.get)
    },
    [IssueVisibilityType.Snoozed]: {
        action: issuesActions.requestGetIssuesSnoozed,
        empty: React.createElement(NoData, { description: COPY_SPECIFIC.NO_ISSUES_SNOOZED }),
        selectors: createAsyncSelectors((state) => state.issues.snoozed.get)
    },
    [IssueVisibilityType.Visible]: {
        action: issuesActions.requestGetIssuesVisible,
        empty: React.createElement(Result, { status: 'success', subTitle: COPY_SPECIFIC.NO_ISSUES_TO_REPORT, title: COPY_SPECIFIC.EVERYTHING_LOOKS_GREAT }),
        selectors: createAsyncSelectors((state) => state.issues.visible.get)
    }
};
export const IssuesList = ({ hideActions, limit, visibility }) => {
    var _a;
    const { queryParams, updateParams } = useQueryParams({
        defaultParams: keyPaginationDefaultQueryParams,
        fallbackParams: keyPaginationFallbackQueryParams
    });
    const typeMap = (_a = visiblityTypeMap[visibility]) !== null && _a !== void 0 ? _a : visiblityTypeMap[IssueVisibilityType.Visible];
    const loadIssues = useAction(typeMap.action);
    const isLoading = useSelector(typeMap.selectors.isRequested);
    const paginatedIssues = useSelector(typeMap.selectors.data);
    const limitedIssues = useMemo(() => getLimitedIssues(paginatedIssues, limit), [limit, paginatedIssues]);
    useEffect(() => {
        loadIssues(queryParams);
    }, [loadIssues, queryParams]);
    return (React.createElement(PaginatedList, { empty: typeMap.empty, listClassName: 'issues-list', loading: isLoading, onChange: updateParams, queryParams: queryParams, renderListItem: (item) => React.createElement(Issue, { hideActions: hideActions, issue: item, key: item.id, visibility: visibility }), resource: limitedIssues }));
};
